import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Phone, MapPin, Instagram, Linkedin, Facebook, MessageCircle, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="32241" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-24 bg-primary/10 animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 font-sans font-normal tracking-wide text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const phoneNumber = "01207 258966";
  const whatsappUrl = "https://wa.me/447956962249";
  return <footer id="footer" className="dark bg-background text-foreground border-t border-primary/20">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585014/img/five_star_roofline_logo.png" alt="Five Star Roofline Logo" className="h-7" />
            </Link>
            <div className="space-y-4 max-w-xs">
              <p className="text-muted-foreground font-sans font-normal leading-relaxed text-base">
                Premium uPVC roofline replacements, dry verge, dry ridge, and EPDM rubber roofing specialists serving the North East.
              </p>
              
              <div className="flex items-start gap-3 text-muted-foreground">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span className="font-sans font-normal text-sm">
                  Serving the North East of England
                </span>
              </div>
              <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5 pl-8">
                {["County Durham", "Washington", "South Shields", "Stanley", "Sunderland", "Newcastle", "Gateshead", "North Shields"].map((location, i) => <li key={location} data-index={i} className="text-muted-foreground/60 font-sans font-normal text-xs">
                    {location}
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-serif text-2xl text-primary font-bold tracking-tight">
              Navigation
            </h3>
            <MenuProvider menu_id="39" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-serif text-2xl text-primary font-bold tracking-tight">
              Get in Touch
            </h3>
            <div className="space-y-4">
              <Link to={`tel:${phoneNumber.replace(/\s/g, "")}`} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-300 group w-fit">
                <Phone className="w-5 h-5 text-primary group-hover:text-primary/80" />
                <span className="font-sans font-normal tracking-wide">{phoneNumber}</span>
              </Link>
              
              <div className="pt-2">
                <p className="text-primary font-serif font-bold text-lg">Christopher Rowell</p>
              </div>

              <Link to="mailto:info@fivestarne.co.uk" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-300 group w-fit">
                <Mail className="w-5 h-5 text-primary group-hover:text-primary/80" />
                <span className="font-sans font-normal tracking-wide">info@fivestarne.co.uk</span>
              </Link>

              <Link to="tel:07956962249" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-300 group w-fit">
                <Phone className="w-5 h-5 text-primary group-hover:text-primary/80" />
                <span className="font-sans font-normal tracking-wide">07956962249</span>
              </Link>

              <Button asChild variant="outline" className="w-full sm:w-auto justify-start gap-3 border-primary/30 bg-primary/10 hover:bg-primary hover:text-primary-foreground text-primary font-bold shadow-lg shadow-primary/10 transition-all duration-300 rounded-full">
                <Link to={whatsappUrl} newTab>
                  <MessageCircle className="w-4 h-4" />
                  Chat on WhatsApp
                </Link>
              </Button>
            </div>

            <div className="pt-4">
              <h4 className="text-sm font-serif text-primary/80 mb-4 uppercase tracking-widest">Connect With Us</h4>
              <div className="flex gap-4">
                {[{
                icon: Instagram,
                label: "Instagram",
                href: "#"
              }, {
                icon: Linkedin,
                label: "LinkedIn",
                href: "#"
              }, {
                icon: Facebook,
                label: "Facebook",
                href: "#"
              }].map((social, i) => <Link key={i} to={social.href} className="p-2 rounded-full bg-primary/10 border border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 flex items-center justify-center" aria-label={social.label} data-index={i}>
                    <social.icon className="w-5 h-5" />
                  </Link>)}
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-primary/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-8 text-[10px] uppercase tracking-widest text-muted-foreground/60 font-sans">
          <div className="space-y-2 max-w-2xl">
            <p>
              &copy; 2026 Five Star Roofline North East. All rights reserved.
            </p>
            <p>
              Trusted local roofing specialists serving Tyne & Wear, County Durham and the North East.
            </p>
            <p>
              Five Star Roofline North East is an independent business and is not affiliated with any third-party websites or directories using similar names.
            </p>
            <div className="flex flex-col gap-2 pt-2">
              <Link to={`tel:${phoneNumber.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-primary transition-colors">
                <Phone className="w-3 h-3" />
                <span>{phoneNumber}</span>
              </Link>
              <div className="flex items-center gap-2">
                <Mail className="w-3 h-3" />
                <span>Get in touch via our website for a free, no-obligation quote</span>
              </div>
            </div>
          </div>
          <Link to="/TermsPage" className="hover:text-primary transition-colors shrink-0">
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>;
}